export default __webpack_public_path__ + "static/media/slider-5.b72519ea.png";